// extracted by mini-css-extract-plugin
export default {"container":"requirements_container__1SpgW","icon":"requirements_icon__REZMH","requirements":"requirements_requirements__Y8Os+"};